import { useState, useEffect } from "react";
import { SwitchContainer } from "../style/Switch";

const Switch = ({ onChange, checked = false, disabled = false }) => {
  const [isChecked, setIsChecked] = useState(checked);

  const handleClick = () => {
    if (disabled) return;
    const newChecked = !isChecked;
    setIsChecked(newChecked);
    if (typeof onChange === "function") {
      onChange(newChecked);
    }
  };

  useEffect(() => {
    setIsChecked(checked);
  }, [checked]);

  return (
    <SwitchContainer>
      <div
        className={`switch ${isChecked ? "active" : ""} ${disabled ? "disabled" : ""}`}
        onClick={handleClick}
      >
        <div className="switch-handle" />
      </div>
    </SwitchContainer>
  );
};

export default Switch;
